import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import Loader from "../../../utils/Loader";
import { toastError, seminarInterestActionId, toastSuccess, ArrangementTypeActionId } from "../../../utils/constants";
import { data } from "jquery";
import moment from "moment";
import { fill_action } from "../../../actions/fillCombo_action";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import { getExhibitorItineraryList_action, insertUpdateExhibitorItinerary_action, deleteExhibitorItinerary_action } from "../../../actions/exhibitor_module_actions/exhItinerary_action/exhItinerary_action";
import Modal from "react-modal";
import JoditEditor from "jodit-react";
import debounce from 'lodash/debounce';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getItenaryUser_action, insertUpdateItineraryNote_action, getItineraryNoteDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/itenary_user_action"

class ExhibitorItenary extends Component {

    // Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            itenaryList: [],
            exhibitionData: [],
            isOpen: false,
            ItneryDeatailIdObj: {},
            Note: '',
            isOpen2: false,
            mapUrl: '',
            ItineraryDate: '',
            ItineraryDateErr: '',
            StartTime: '',
            StartTimeErr: '',
            EndTime: '',
            EndTimeErr: '',
            isOpen3: false,
            isOpen4: false,
            ArrangementTypeID: '',
            ArrangementTypeList: '',
            HtmlContent: '',
            ExhibitorItineraryID: '',
            isAdd: false
        }
    }

    componentDidMount() {
        this.getFillList(ArrangementTypeActionId, '', '', '', '', '')
        this.getExhibitorItineraryList()
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === ArrangementTypeActionId) {
                            this.setState({
                                ArrangementTypeList: data.data
                            })
                        }
                        resolve(true)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getExhibitorItineraryList() {
        const { typeID, typeList, productAll, companyAll, countryAll } = this.state
        this.setState({ isLoading: true })

        return new Promise((resolve => {
            this.props.getExhibitorItineraryList_action()
                .then((data) => {
                    if (data.error != 1) {

                        if (data.data.length > 0) {
                            const itenaryData = data.data[0]
                            const exhibitionData = data.data?.[1]?.[0]

                            for (var a = 0; a < itenaryData.length; a++) {
                                for (var b = 0; b < itenaryData.length - 1 - a; b++) {
                                    let dateA = new Date(itenaryData[b].Date);
                                    let dateB = new Date(itenaryData[b + 1].Date);

                                    let datePartA = dateA.toISOString().split('T')[0];
                                    let datePartB = dateB.toISOString().split('T')[0];

                                    if (datePartA == datePartB) {
                                        // Swap the elements if they are in the wrong order
                                        if (dateA > dateB) {
                                            [itenaryData[b], itenaryData[b + 1]] = [itenaryData[b + 1], itenaryData[b]];
                                        }
                                    }
                                }
                            }
                            console.log("sagar------------->", itenaryData)
                            var DateArr = []
                            var DateArrofObj = []
                            for (var b = 0; b < itenaryData.length; b++) {
                                if (!DateArr.includes(itenaryData[b].Date)) {
                                    DateArr.push(itenaryData[b].Date)
                                }
                            }
                            for (var a = 0; a < DateArr.length; a++) {
                                var count = 0
                                for (var b = 0; b < itenaryData.length; b++) {
                                    if (itenaryData[b].Date == DateArr[a]) {
                                        count++
                                    }
                                }
                                var countObj = {
                                    Date: DateArr[a],
                                    Available: 1,
                                    count: count
                                }
                                DateArrofObj.push(countObj)
                            }

                            console.log(DateArrofObj)

                            for (var b = 0; b < itenaryData.length; b++) {
                                itenaryData[b].rowspan = null
                                for (var a = 0; a < DateArrofObj.length; a++) {
                                    if (DateArrofObj[a].Available == 1) {
                                        if (itenaryData[b].Date == DateArrofObj[a].Date) {
                                            // console.log('ooo',a,b,count,DateArr[a])
                                            itenaryData[b].rowspan = DateArrofObj[a].count
                                            DateArrofObj[a].Available = 0
                                            break
                                        }
                                    }
                                }
                            }
                            console.log("test", itenaryData)

                            for (var a = 0; a < itenaryData.length; a++) {
                                var mapHtmlArr = itenaryData[a].MapUrl != null ? itenaryData[a].MapUrl.split(' ') : []
                                for (var i = 0; i < mapHtmlArr.length; i++) {
                                    if (mapHtmlArr[i].includes('width')) {
                                        var widthArr = mapHtmlArr[i].split('=')
                                        // mapHtmlArr[i].split('=')[1] = "200"
                                        var newWidth = mapHtmlArr[i].replace(`${mapHtmlArr[i].split('=')[1]}`, '"400"')
                                    }
                                    if (mapHtmlArr[i].includes('height')) {
                                        var newHeightArr = mapHtmlArr[i].split('=')
                                        // mapHtmlArr[i].split('=')[1] = "200"
                                        var newHeight = mapHtmlArr[i].replace(`${mapHtmlArr[i].split('=')[1]}`, '"400"')
                                    }
                                }
                                for (var i = 0; i < mapHtmlArr.length; i++) {
                                    if (mapHtmlArr[i].includes('width')) {
                                        mapHtmlArr[i] = newWidth
                                    }
                                    if (mapHtmlArr[i].includes('height')) {
                                        mapHtmlArr[i] = newHeight
                                    }
                                }
                                var mapHtml = mapHtmlArr.join(' ')
                                itenaryData[a].MapUrl = mapHtml
                            }
                            console.log("sagar-->1234", itenaryData)
                            this.setState({ itenaryList: itenaryData, exhibitionData: exhibitionData })

                        }
                        this.setState({ isLoading: false })
                    }
                })
        }))
    }

    deleteRecord() {
        const { ExhibitorItineraryID } = this.state
        this.setState({ isLoading: true })

        return new Promise((resolve => {
            this.props.deleteExhibitorItinerary_action(ExhibitorItineraryID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Itinerary Deleted Successfully")
                        this.getExhibitorItineraryList()
                        this.setState({ isLoading: false, isOpen3: false })
                    }
                })
        }))
    }

    insertUpdateItinerary() {
        const { ItneryDeatailIdObj, Note, StartTime, EndTime, ItineraryDate, ArrangementTypeID, HtmlContent, mapUrl, ExhibitorItineraryID } = this.state
        this.setState({ isLoading: true })
        const array = []
        array.push({
            ItineraryDate: ItineraryDate ? moment(ItineraryDate).format('YYYY-MM-DD') : null,
            StartTime: StartTime,
            EndTime: EndTime,
            ArrangementTypeID: ArrangementTypeID,
            HtmlContent: HtmlContent,
            MapUrl: mapUrl,
            "ItineraryNoteID": 0,
            "DelegateSeminarDetailsID": 0,
            "B2BMeetingID": 0,
            "DelegateItineraryID": 0,
            "Note": Note?.trim() ? Note : null
        })
        return new Promise((resolve => {
            this.props.insertUpdateExhibitorItinerary_action(array, ExhibitorItineraryID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Itinerary Added Successfully")
                        this.clearValue()
                        this.getExhibitorItineraryList()
                        this.setState({ isOpen: false, Note: '' })
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
        }))
    }

    getItineraryNoteDetails() {
        const { ItneryDeatailIdObj, Note } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getItineraryNoteDetails_action(ItneryDeatailIdObj.ItineraryNoteID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, Note: data.data?.[0]?.Note ?? '' })
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
        }))
    }

    onPop(item) {
        this.setState({
            isOpen: true,
            ItneryDeatailIdObj: {
                ItineraryNoteID: item.ItineraryNoteID,
                DelegateSeminarDetailsID: item.DelegateSeminarDetailsID,
                B2BMeetingID: item.B2BMeetingID,
                DelegateItineraryID: item.DelegateItineraryID,
                ExhibitorItineraryID: item.ExhibitorItineraryID,
                ExhibitorSeminarDetailsID: item.ExhibitorSeminarDetailsID,
                VisitorItineraryID: item.VisitorItineraryID,
                ExhvisitorSeminarDetailsID: item.ExhvisitorSeminarDetailsID,
            },
            Note: item.Note ?? ''
        },
            // () => this.getItineraryNoteDetails()
        )
    }

    insertUpdateItineraryNote() {
        const { ItneryDeatailIdObj, Note } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.insertUpdateItineraryNote_action(ItneryDeatailIdObj.ItineraryNoteID, ItneryDeatailIdObj.DelegateSeminarDetailsID, ItneryDeatailIdObj.B2BMeetingID, ItneryDeatailIdObj.DelegateItineraryID, Note?.trim() ? Note : null, ItneryDeatailIdObj.ExhibitorItineraryID, ItneryDeatailIdObj.ExhibitorSeminarDetailsID, ItneryDeatailIdObj.VisitorItineraryID, ItneryDeatailIdObj.ExhvisitorSeminarDetailsID)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Note Updated Successfully")
                        this.getExhibitorItineraryList()
                        this.setState({ isOpen: false, Note: '' })
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
        }))
    }

    clearValue() {
        this.setState({
            isOpen2: false,
            mapUrl: '',
            Note: '',
            ItineraryDate: null,
            StartTime: '',
            EndTime: '',
            ArrangementTypeID: '',
            HtmlContent: '',
            HtmlContentErr: '',
            ItineraryDateErr: '',
            StartTimeErr: '',
            EndTimeErr: '',
            ArrangementTypeIDErr: '',
            ExhibitorItineraryID: ''
        })
    }

    openPrintView = () => {
        this.setState({ isLoading: true });

        const content = document.getElementById("itinerary-pdf");

        if (!content) {
            this.setState({ isLoading: false });
            return;
        }

        const currentDateTime = moment().format("DD MMM YYYY hh:mm A");

        let html = content.outerHTML;

        // Remove bootstrap flex layout for print
        html = html.replaceAll(
            "p-0 m-0 d-flex justify-content-between",
            "p-0 m-0"
        );

        // Remove bootstrap text-center classes
        html = html.replaceAll("text-center", "text-left");

        // Remove center alignments
        html = html.replace(/text-align\s*:\s*center/gi, "text-align:left");
        html = html.replace(/align=['"]center['"]/gi, "");

        // Remove center tags
        html = html.replace(/<center>/gi, "<div>");
        html = html.replace(/<\/center>/gi, "</div>");

        // Convert UL/LI to DIV for better print layout
        html = html.replace(/<ul[^>]*>/gi, "<div>");
        html = html.replace(/<\/ul>/gi, "</div>");
        html = html.replace(/<li[^>]*>/gi, "<div>");
        html = html.replace(/<\/li>/gi, "</div>");

        const printFrame = document.createElement("iframe");

        printFrame.style.position = "fixed";
        printFrame.style.right = "0";
        printFrame.style.bottom = "0";
        printFrame.style.width = "0";
        printFrame.style.height = "0";
        printFrame.style.border = "0";

        document.body.appendChild(printFrame);

        const doc = printFrame.contentWindow.document;

        doc.open();

        doc.write(`
            <html>
            <head>
                <title>Itinerary</title>
    
                <style>
        body{
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 15px;
        }
    
        table{
            width:100%;
            border-collapse:collapse;
        }
    
        table,
        th,
        td{
            border:1.5px solid #333 !important;
        }
    
        th,
        td{
            padding:8px;
        }
    
        th{
            text-align:center;
            font-weight:bold;
        }
    
        .bi,
        button,
        .btn{
            display:none !important;
        }
    
        .text-aqua{
            color:#3dbca7 !important;
            display:block;
            text-align:left !important;
            margin-top:4px;
            font-weight:500;
        }
    
        /* Date & Time columns */
        table td:first-child,
        table td:nth-child(2),
        table th:first-child,
        table th:nth-child(2){
            text-align:center !important;
            vertical-align:middle !important;
        }
    
        /* Activities column ONLY */
        table td:last-child{
            text-align:left !important;
            vertical-align:top !important;
            padding-left:10px !important;
        }
    
        table td:last-child,
        table td:last-child *,
        table td:last-child div,
        table td:last-child span,
        table td:last-child p{
            text-align:left !important;
            vertical-align:top !important;
            justify-content:flex-start !important;
            align-items:flex-start !important;
        }
    
        table td:last-child > div{
            width:100% !important;
            text-align:left !important;
        }
    
        /* Remove bullets */
        ul,
        li{
            list-style:none !important;
            margin:0 !important;
            padding:0 !important;
        }
    
        /* Remove bootstrap flex alignment in print */
        .d-flex{
            justify-content:flex-start !important;
            align-items:flex-start !important;
        }
    
        /* Maps */
        iframe{
            width:320px !important;
            height:220px !important;
            border:none !important;
            display:block !important;
            margin:5px 0 !important;
        }
    
        /* Avoid row breaking */
        tr{
            page-break-inside:avoid !important;
            break-inside:avoid !important;
        }
    
        td,
        th{
            page-break-inside:avoid !important;
            break-inside:avoid !important;
        }
    
        thead{
            display:table-header-group !important;
        }
    
        .table-responsive{
            overflow:visible !important;
        }
    
        @page{
            size:A4;
            margin:8mm;
        }
    </style>
            </head>
    
            <body>
    
                <div
                    style="
                        display:flex;
                        justify-content:space-between;
                        align-items:center;
                        margin-bottom:10px;
                        padding-bottom:5px;
                        border-bottom:1px solid #ddd;
                    "
                >
                    <div
                        style="
                            font-size:18px;
                            font-weight:bold;
                        "
                    >
                        Exhibitor Itinerary
                    </div>
    
                    <div
                        style="
                            font-size:12px;
                            font-weight:bold;
                        "
                    >
                        Generated On: ${currentDateTime}
                    </div>
                </div>
    
                ${html}
    
            </body>
            </html>
        `);

        doc.close();

        printFrame.onload = () => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();

            setTimeout(() => {
                document.body.removeChild(printFrame);
            }, 3000);
        };

        setTimeout(() => {
            this.setState({ isLoading: false });
        }, 3000);
    };

    buttons = [
        "undo",
        "redo",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "superscript",
        "subscript",
        "|",
        "align",
        "|",
        "ul",
        "ol",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "link",
        "table",
        "|",
        "hr",
        // "eraser",
        // "copyformat",
        "|",
        // "fullsize",
        // "selectall",
        "print",
        "|",
        // "source",
        "|",
        {
            name: "insertMergeField",
            tooltip: "Insert Merge Field",
            iconURL: "images/merge.png",
            popup: (editor, current, self, close) => {
                const onSelected = (e) => {
                    const mergeField = e.target.value;
                    if (mergeField) {
                        console.log(mergeField);
                        editor.selection.insertNode(
                            editor.create.inside.fromHTML("{{" + mergeField + "}}")
                        );
                    }
                };

                const divElement = editor.create.div("merge-field-popup");
                const labelElement = document.createElement("label");
                labelElement.setAttribute("class", "merge-field-label");
                labelElement.textContent = "Merge field: ";
                divElement.appendChild(labelElement);

                const selectElement = document.createElement("select");
                selectElement.setAttribute("class", "merge-field-select");
                selectElement.appendChild(
                    this.createOptionGroupElement(this.facilityMergeFields, "Facility")
                );
                selectElement.appendChild(
                    this.createOptionGroupElement(
                        this.inspectionMergeFields,
                        "Inspection"
                    )
                );
                selectElement.onchange = onSelected;
                divElement.appendChild(selectElement);

                console.log(divElement);
                return divElement;
            },
        },
        {
            name: "copyContent",
            tooltip: "Copy HTML to Clipboard",
            iconURL: "images/copy.png",
            exec: (editor) => {
                const html = editor.value;
                this.copyStringToClipboard(html);
            },
        },
    ];

    editorConfig = {
        readonly: false,
        toolbar: true,
        spellcheck: true,
        language: "en",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: true,
        showWordsCounter: true,
        showXPathInStatusbar: false,
        askBeforePasteHTML: true,
        askBeforePasteFromWord: true,
        buttons: this.buttons,
        uploader: {
            insertImageAsBase64URI: true,
        },
    };

    handleChangeContent = (newContent) => {
        this.setState({ HtmlContent: newContent });
    };

    render() {
        const { isLoading, itenaryList, exhibitionData, isOpen, Note, ItneryDeatailIdObj, isOpen2, mapUrl, ItineraryDate, ItineraryDateErr, StartTime, StartTimeErr, EndTime, EndTimeErr, isOpen3, isOpen4, ArrangementTypeID, ArrangementTypeList, HtmlContent, isAdd } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content with-dr-container" style={{ marginTop: '3rem' }}>
                    <div className="">
                        <div className="">
                            <ExhibitorTopMenu />
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12 p-0 mt-2">
                                <div class="card rounded-0 pt-1">
                                    <div class="mb-2" style={{ textAlign: 'right' }}>
                                        <button
                                            className="btn btn-aqua"
                                            onClick={this.openPrintView}
                                        >
                                            Print
                                        </button>
                                        <button
                                            className="btn btn-aqua mx-2"
                                            onClick={() => this.setState({ isOpen2: true, isAdd: true })}
                                        >
                                            Add Itinerary+
                                        </button>
                                    </div>
                                    <div class="card-body p-1" id="itinerary-pdf">
                                        <div class="table-responsive ">
                                            <table class="table border td-summery table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '200px' }} className="text-center">Date</th>
                                                        <th style={{ width: '200px' }} className="text-center">
                                                            IST Time (GMT+5:30)
                                                        </th>
                                                        <th>Activities</th>
                                                    </tr>
                                                </thead>
                                                < tbody >
                                                    {itenaryList.length > 0
                                                        ? itenaryList.map((item, index) => (
                                                            <tr key={index}>
                                                                {item.rowspan != null && (
                                                                    <td style={{ width: '100px' }} rowSpan={item.rowspan}>
                                                                        {item.Date ? (
                                                                            <>
                                                                                {moment(item.Date).format('Do MMM YYYY')}
                                                                                <br />
                                                                                <small>{moment(item.Date).format('dddd')}</small>
                                                                            </>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                    </td>
                                                                )}

                                                                <td style={{ width: '100px' }}>
                                                                    {item.StartTime != null &&
                                                                        item.StartTime !== '' &&
                                                                        item.EndTime != null &&
                                                                        item.EndTime !== ''
                                                                        ? `${moment
                                                                            .utc(new Date(item.StartTime).toUTCString())
                                                                            .format('HH:mm')} to ${moment
                                                                                .utc(new Date(item.EndTime).toUTCString())
                                                                                .format('HH:mm')}`
                                                                        : ''}{' '}
                                                                    (hrs)
                                                                </td>

                                                                {item.ArrangementType === 'Seminar' ? (
                                                                    <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                        <ul className="p-0 m-0">
                                                                            <li
                                                                                className="p-0 m-0 d-flex justify-content-between"
                                                                                style={{ listStyle: 'none' }}
                                                                            >
                                                                                <span>
                                                                                    Attend the {item.SeminarName} seminar,{' '}
                                                                                    {item.Sspaneaker} as the speaker
                                                                                </span>

                                                                                <span
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => this.onPop(item)}
                                                                                >
                                                                                    <i
                                                                                        className={
                                                                                            item.Note
                                                                                                ? 'bi bi-file-earmark-check-fill'
                                                                                                : 'bi bi-journal-plus'
                                                                                        }
                                                                                    ></i>
                                                                                </span>
                                                                            </li>

                                                                            {item.Note && (
                                                                                <li
                                                                                    style={{
                                                                                        listStyle: 'none',
                                                                                        marginTop: '5px'
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        className="text-aqua"
                                                                                        style={{
                                                                                            display: 'block',
                                                                                            maxWidth: '100%',
                                                                                            whiteSpace: 'normal',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'break-word',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                    >
                                                                                        Note: {item.Note}
                                                                                    </span>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </td>
                                                                ) : item.ArrangementType === 'B2B Meeting' ? (
                                                                    <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                        <ul className="p-0 m-0">
                                                                            <li
                                                                                className="p-0 m-0 d-flex justify-content-between"
                                                                                style={{ listStyle: 'none' }}
                                                                            >
                                                                                <span>
                                                                                    B2B Meeting at {item.B2BLocation} with{' '}
                                                                                    {item.PersonName}, {item.CompanyName}
                                                                                </span>

                                                                                <span
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => this.onPop(item)}
                                                                                >
                                                                                    <i
                                                                                        className={
                                                                                            item.Note
                                                                                                ? 'bi bi-file-earmark-check-fill'
                                                                                                : 'bi bi-journal-plus'
                                                                                        }
                                                                                    ></i>
                                                                                </span>
                                                                            </li>

                                                                            {item.Note && (
                                                                                <li
                                                                                    style={{
                                                                                        listStyle: 'none',
                                                                                        marginTop: '5px'
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        className="text-aqua"
                                                                                        style={{
                                                                                            display: 'block',
                                                                                            maxWidth: '100%',
                                                                                            whiteSpace: 'normal',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'break-word',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                    >
                                                                                        Note: {item.Note}
                                                                                    </span>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </td>
                                                                ) : item.ArrangementType === 'Invitation Event' ? (
                                                                    <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                        <ul className="p-0 m-0">
                                                                            <li
                                                                                className="p-0 m-0 d-flex justify-content-between"
                                                                                style={{ listStyle: 'none' }}
                                                                            >
                                                                                <span>
                                                                                    {item.InvitationTypeName} at{' '}
                                                                                    {item.InvitationPlace}
                                                                                </span>

                                                                                <span
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => this.onPop(item)}
                                                                                >
                                                                                    <i
                                                                                        className={
                                                                                            item.Note
                                                                                                ? 'bi bi-file-earmark-check-fill'
                                                                                                : 'bi bi-journal-plus'
                                                                                        }
                                                                                    ></i>
                                                                                </span>
                                                                            </li>

                                                                            {item.Note && (
                                                                                <li
                                                                                    style={{
                                                                                        listStyle: 'none',
                                                                                        marginTop: '5px'
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        className="text-aqua"
                                                                                        style={{
                                                                                            display: 'block',
                                                                                            maxWidth: '100%',
                                                                                            whiteSpace: 'normal',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'break-word',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                    >
                                                                                        Note: {item.Note}
                                                                                    </span>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </td>
                                                                ) : (
                                                                    <td style={{ width: '600px', maxWidth: '600px' }}>
                                                                        <ul className="p-0 m-0">
                                                                            <li
                                                                                className="p-0 m-0 d-flex justify-content-between"
                                                                                style={{ listStyle: 'none' }}
                                                                            >
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: `${item.HtmlContent != null
                                                                                            ? item.HtmlContent
                                                                                            : ''
                                                                                            }<br/>${item.MapUrl != null
                                                                                                ? item.MapUrl
                                                                                                : ''
                                                                                            }`
                                                                                    }}
                                                                                ></div>
                                                                                <div>
                                                                                    <span
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => this.setState({
                                                                                            isOpen2: true,
                                                                                            ItineraryNoteID: item.ItineraryNoteID,
                                                                                            DelegateSeminarDetailsID: item.DelegateSeminarDetailsID,
                                                                                            ArrangementType: item.ArrangementType,
                                                                                            Note: item.Note,
                                                                                            ItineraryDate: item.Date ? moment(item.Date, "YYYY-MM-DD HH:mm").toDate() : null,
                                                                                            StartTime: item.StartTime ? moment(item.StartTime).format('HH:mm') : null,
                                                                                            EndTime: item.EndTime ? moment(item.EndTime).format('HH:mm') : null,
                                                                                            HtmlContent: item.HtmlContent,
                                                                                            MapUrl: item.MapUrl,
                                                                                            ArrangementTypeID: item.ArrangementTypeID,
                                                                                            ExhibitorItineraryID: item.ExhibitorItineraryID,
                                                                                            isAdd: false
                                                                                        })}
                                                                                    >
                                                                                        <i
                                                                                            className={'fa fa-pencil text-aqua'}
                                                                                        ></i>
                                                                                    </span>
                                                                                    <span
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => this.setState({ isOpen3: true, ExhibitorItineraryID: item.ExhibitorItineraryID })}
                                                                                    >
                                                                                        <i
                                                                                            className={'fa fa-trash text-danger mx-2'}
                                                                                        ></i>
                                                                                    </span>
                                                                                    <span
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => this.onPop(item)}
                                                                                    >
                                                                                        <i
                                                                                            className={
                                                                                                item.Note
                                                                                                    ? 'bi bi-file-earmark-check-fill'
                                                                                                    : 'bi bi-journal-plus'
                                                                                            }
                                                                                        ></i>
                                                                                    </span>
                                                                                </div>
                                                                            </li>

                                                                            {item.Note && (
                                                                                <li
                                                                                    style={{
                                                                                        listStyle: 'none',
                                                                                        marginTop: '5px'
                                                                                    }}
                                                                                >
                                                                                    <span
                                                                                        className="text-aqua"
                                                                                        style={{
                                                                                            display: 'block',
                                                                                            maxWidth: '100%',
                                                                                            whiteSpace: 'normal',
                                                                                            wordBreak: 'break-word',
                                                                                            overflowWrap: 'break-word',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                    >
                                                                                        Note: {item.Note}
                                                                                    </span>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))
                                                        : (
                                                            <tr style={{ backgroundColor: '#f3f3f3' }}>
                                                                <td colSpan={3}>No Records Found</td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


                <Modal
                    isOpen={isOpen2}
                    onRequestClose={() => this.clearValue()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header text-white">
                                <h6 className="modal-title">{!isAdd ? 'Update' : 'Add'} Itinerary</h6>
                                <button type="button" className="btn-close btn-close-white"
                                    onClick={() => this.clearValue()}
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-4">
                                        <label>Itinerary Date<span className="text-red">*</span></label>
                                        <DatePicker
                                            selected={ItineraryDate}
                                            onChange={(date) =>
                                                this.setState({
                                                    ItineraryDate: date,
                                                    ItineraryDateErr: ""
                                                })}
                                            onChange={(value) => this.setState({ ItineraryDate: value })}
                                            dateFormat={"dd/MM/yyyy"}
                                            className="form-control"
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="DD/MM/YYYY"
                                            dayClassName={() => "example-datepicker-day-class"}
                                            popperClassName="example-datepicker-class" />
                                        {<span className='text-danger text-start text-left d-block mt-1'>{ItineraryDateErr}</span>}
                                    </div>
                                    <div className="col-xl-2">
                                        <label>Start Time<span className="text-red">*</span></label>
                                        <input type="time"
                                            id="time1"
                                            class="form-control"
                                            value={StartTime}
                                            onChange={(e) => this.setState({ StartTime: e.target.value })}
                                        />{<span className='text-danger text-start text-left d-block mt-1'>{StartTimeErr}</span>}
                                    </div>
                                    <div className="col-xl-2">
                                        <label>End Time<span className="text-red">*</span></label>
                                        <input type="time"
                                            id="time1"
                                            class="form-control"
                                            value={EndTime}
                                            onChange={(e) => this.setState({ EndTime: e.target.value })}
                                        />{<span className='text-danger text-start text-left d-block mt-1'>{EndTimeErr}</span>}
                                    </div>
                                    {/* <div className="col-xl-4">
                                        <label>Arrangement Type<span className="text-red">*</span></label>
                                        <select className="form-control"
                                            value={ArrangementTypeID}
                                            onChange={(e) => this.setState({ ArrangementTypeID: e.target.value })}
                                        >
                                            <option value={''}>Select</option>
                                            {
                                                ArrangementTypeList.length > 0 && ArrangementTypeList.map((data) => (
                                                    <option key={data.ArrangementTypeID} value={data.ArrangementTypeID}>{data.Name}</option>
                                                ))
                                            }
                                        </select>{<span className='text-danger text-start text-left d-block mt-1'>{EndTimeErr}</span>}
                                    </div> */}
                                    <div className="col-xl-12 mt-2">
                                        <label>Html Content</label>
                                        <JoditEditor
                                            ref={this.editor}
                                            value={this.state.HtmlContent}
                                            config={this.editorConfig}
                                            onChange={this.handleChangeContent}
                                        />
                                    </div>
                                    {/* <div className="col-xl-12 mt-2">
                                        <label>Map Url</label>
                                        <div className="d-flex">
                                            <input
                                                type="text"
                                                style={{ marginRight: '10px' }}
                                                className="form-control"
                                                value={mapUrl}
                                                onChange={(e) => {
                                                    if (e.target.value != '') {
                                                        const event = e.target.value.replace('style="border:0;"', 'style={{ border: 0 }}')
                                                        this.setState({ mapUrl: event })
                                                    } else {
                                                        this.setState({ mapUrl: '' })
                                                    }
                                                }}
                                            />
                                            <button type="button" className="btn btn-outline-secondary ad-fil-btn"
                                                onClick={e => this.setState({ mapUrl: '' })}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                        <div className="col-md-12 mt-4" style={{ textAlign: 'center' }}>
                                            <div>
                                                <div dangerouslySetInnerHTML={{ __html: mapUrl }} />
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-aqua" onClick={() => this.insertUpdateItinerary()}>
                                    Submit
                                </button>
                                <button className="btn btn-gray"
                                    onClick={() => this.clearValue()}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={isOpen}
                    onRequestClose={() => this.setState({ isOpen: false, Note: '' })}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    ariaHideApp={false}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header text-white">
                                <h6 className="modal-title">{ItneryDeatailIdObj.ItineraryNoteID ? 'Update' : 'Add'} Note</h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ isOpen: false, Note: '' })} />
                            </div>
                            <div className="modal-body">
                                <div className="col-xl-12 mb-3">
                                    <label>Note</label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        cols={5}
                                        rows={8}
                                        value={Note}
                                        onChange={(e) =>
                                            this.setState({ Note: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-aqua" onClick={() => this.insertUpdateItineraryNote()}>
                                    Submit
                                </button>
                                <button className="btn btn-gray" onClick={() => this.setState({ isOpen: false, Note: '' })}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={isOpen3} onRequestClose={() => this.setState({ isOpen3: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text">Confirm Delete!</h5>
                                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen3: false })} ></button>
                            </div>
                            <div class="modal-body">
                                Are you sure you want to delete this record?
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.deleteRecord()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen3: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, getExhibitorItineraryList_action, insertUpdateExhibitorItinerary_action, deleteExhibitorItinerary_action, fill_action, getItenaryUser_action, insertUpdateItineraryNote_action, getItineraryNoteDetails_action
})(ExhibitorItenary))